import { TERMINALS, ALL_CAPACITY, CAPACITY, 
  RATE_SHEET, IMPORT_SHEET, QUOTE, CLEAR_QUOTE, 
  FLAT_RATE, JOB_REQUEST, POTENTIAL_DESTINATIONS, 
  STATES, DESTINATIONS, ZIP_CODES } from './DashboardActions';
import { Map } from 'immutable';
import { combineReducers } from 'redux';

let defaultState = new Map({
  isFetching: false,
  error: false,
  data: []
});


export function capacity(state = new Map({
  isFetching: false}), action) {
  let output = null;
  let substate = {};
  switch (action.type) {
    case ALL_CAPACITY.REQUEST:
      return state.merge({
        isFetching: true,
      });
    case ALL_CAPACITY.SUCCESS:    
      action.payload.forEach(obj => {
        substate[obj.terminal] = {};
        substate[obj.terminal]['isFetching'] = false;
        substate[obj.terminal]['error'] = false;
        substate[obj.terminal] = Object.assign(substate[obj.terminal], obj);
      });
      state = state.set('isFetching', false);
      return state.mergeDeep(substate);
    case ALL_CAPACITY.FAILURE:
      return state.merge({
        isFetching: false,
        error: action.error
      });
    case CAPACITY.REQUEST:
      substate[action.terminal] = {};
      substate[action.terminal]['isFetching'] = true;
      substate[action.terminal]['error'] = false;
      output = Object.assign(state.toObject() || {}, substate);
      return state.merge(output);
    case CAPACITY.SUCCESS:
      substate[action.terminal] = {};
      substate[action.terminal]['isFetching'] = false;
      substate[action.terminal]['error'] = false;
      substate[action.terminal] = Object.assign(substate[action.terminal], action.payload);
      output = Object.assign(state.toObject() || {}, substate);
      return state.merge(output);
    case CAPACITY.FAILURE:
      substate[action.terminal] = {};
      substate[action.terminal]['isFetching'] = false;
      substate[action.terminal]['error'] = action.error;
      output = Object.assign(state.toObject() || {}, substate);
      return state.merge(output);
    default:
      return state;
  }
}

export function terminals(state = defaultState, action) {
  switch (action.type) {
    case TERMINALS.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching
      }));
    case TERMINALS.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        data: action.payload
      }));
    case TERMINALS.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    default:
      return state;
  }
}

export function potentialDestinations(state = defaultState, action) {
  switch (action.type) {
    case POTENTIAL_DESTINATIONS.REQUEST:
      return Map({
        isFetching: true
      });
    case POTENTIAL_DESTINATIONS.SUCCESS:
      return Map({
        isFetching: false,
        data: action.payload
      });
    case POTENTIAL_DESTINATIONS.FAILURE:
      return Map({
        isFetching: false,
        error: action.error
      });
    default:
      return state;
  }
}

export function jobRequest(state = defaultState, action) {
  switch (action.type) {
    case JOB_REQUEST.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case JOB_REQUEST.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        error: false,
        data: action.payload
      });
    case JOB_REQUEST.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    default:
      return state;
  }
}

export function quote(state = defaultState, action) {
  switch (action.type) {
    case QUOTE.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case QUOTE.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        data: action.payload
      });
    case QUOTE.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    case CLEAR_QUOTE:
      return defaultState;
    default:
      return state;
  }
}

export function flatRate(state = defaultState, action) {
  switch (action.type) {
    case FLAT_RATE.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case FLAT_RATE.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        data: action.payload
      });
    case FLAT_RATE.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    default:
      return state;
  }
}

export function rateSheet(state = defaultState, action) {
  switch (action.type) {
    case RATE_SHEET.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case RATE_SHEET.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        data: action.payload
      });
    case RATE_SHEET.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    default:
      return state;
  }
}
export function destinations(state = defaultState, action) {
  switch (action.type) {
    case DESTINATIONS.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case DESTINATIONS.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        data: action.payload
      });
    case DESTINATIONS.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    default:
      return state;
  }
}

export function states(state = defaultState, action) {
  switch (action.type) {
    case STATES.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case STATES.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        data: action.payload
      });
    case STATES.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    default:
      return state;
  }
}

export function zipCodes(state = defaultState, action) {
  switch (action.type) {
    case ZIP_CODES.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case ZIP_CODES.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        data: action.payload
      });
    case ZIP_CODES.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    default:
      return state;
  }
}


export function importSheet(state = defaultState, action) {
  switch (action.type) {
    case IMPORT_SHEET.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case IMPORT_SHEET.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        data: action.payload
      });
    case IMPORT_SHEET.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    default:
      return state;
  }
}

export default combineReducers({
  terminals,
  capacity,
  quote,
  flatRate,
  jobRequest,
  rateSheet,
  potentialDestinations,
  importSheet,
  states,
  zipCodes,
  destinations
});


// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardReducer.js